import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, Newspaper, Package, Inbox, ClipboardList, Mail } from "lucide-react";
import { adminStats } from "../../lib/api";

const cards = [
  { key: "upcoming_events", label: "Upcoming events", icon: CalendarDays, to: "/admin/events" },
  { key: "news", label: "News posts", icon: Newspaper, to: "/admin/news" },
  { key: "equipment", label: "Equipment items", icon: Package, to: "/admin/equipment" },
  { key: "pending_enquiries", label: "Pending enquiries", icon: Inbox, to: "/admin/enquiries", highlight: true },
  { key: "active_bookings", label: "Active bookings", icon: ClipboardList, to: "/admin/bookings" },
  { key: "submissions", label: "Form submissions", icon: Mail, to: "/admin/enquiries" },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { adminStats().then(setStats).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-display font-bold text-2xl text-nead-navy" data-testid="admin-dashboard-title">Dashboard</h1>
      <p className="mt-1 text-sm text-nead-navy/55">An overview of everything happening at NEAD CIC.</p>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map((c) => (
          <Link key={c.key} to={c.to} data-testid={`stat-${c.key}`} className={`group rounded-2xl border p-6 bg-white transition-all hover:shadow-lg hover:-translate-y-0.5 ${c.highlight && stats[c.key] > 0 ? "border-nead-pink/40" : "border-black/[0.07]"}`}>
            <div className="flex items-center justify-between">
              <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${c.highlight && stats[c.key] > 0 ? "grad-pink-cyan" : "bg-nead-mist"}`}>
                <c.icon className={`h-5 w-5 ${c.highlight && stats[c.key] > 0 ? "text-white" : "text-nead-navy/60"}`} />
              </div>
            </div>
            <div className="mt-5 font-display font-bold text-3xl text-nead-navy tabular-nums">{stats[c.key] ?? "–"}</div>
            <div className="mt-1 text-sm text-nead-navy/55">{c.label}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
